const COMMENTS = [
  {
    name: '吃瓜不吐籽',
    time: '2小时前',
    content: '这个网站太顶了！每天上班第一件事就是打开黑料每日大赛看看今天又有什么新瓜，比刷微博有效率多了。编辑部真的牛，每次整理得明明白白。',
    likes: 892,
  },
  {
    name: '瓜田里的守望者',
    time: '5小时前',
    content: '今天的焦点专题那篇深度调查看得我目瞪口呆，原来娱乐圈背后还有这么多不为人知的事。感谢小编的辛苦整理，这种深度内容多多益善！',
    likes: 654,
  },
  {
    name: '一只安静的猹',
    time: '8小时前',
    content: '已经推荐给了整个部门同事，现在每天中午吃饭都在讨论今日黑料排行榜上的瓜。编辑部能不能出一期年度十大名场面总结？期待期待！',
    likes: 431,
  },
  {
    name: '瓜熟蒂落',
    time: '12小时前',
    content: '对比了好几个同类型网站，黑料每日大赛的信息更新速度是最快的，而且分类特别清晰。话题标签功能太方便了，想看什么类型一目了然。',
    likes: 326,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            吃瓜群众都在说什么？来看看大家的热评
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-lg bg-background-100 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}